import { render, staticRenderFns } from "./ChainWidths.vue?vue&type=template&id=512ef6d4&scoped=true"
import script from "./ChainWidths.vue?vue&type=script&lang=js"
export * from "./ChainWidths.vue?vue&type=script&lang=js"
import style0 from "./ChainWidths.vue?vue&type=style&index=0&id=512ef6d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512ef6d4",
  null
  
)

export default component.exports